/* unplugin-vue-components disabled */import { render } from "./typedata.vue?vue&type=template&id=3f008037&scoped=true"
import script from "./typedata.vue?vue&type=script&lang=js"
export * from "./typedata.vue?vue&type=script&lang=js"

import "./typedata.vue?vue&type=style&index=0&id=3f008037&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f008037"]])

export default __exports__